// Canonical domains for the Azeka properties.
export const GLOBAL_ORIGIN = "https://azekaglobal.com";
export const HEALTH_ORIGIN = "https://azekahealth.com";
// Back-compat export (Global is the default canonical for the corporate app).
export const CANONICAL_ORIGIN = GLOBAL_ORIGIN;

// Hosts that collapse onto the Global canonical domain.
const GLOBAL_FAMILY = [
  "azekaglobal.com",
  "www.azekaglobal.com",
  "azekaglobaltrade.com",
  "www.azekaglobaltrade.com",
];
// Hosts that belong to the Health canonical domain.
const HEALTH_FAMILY = ["azekahealth.com", "www.azekahealth.com"];

// Non-canonical hosts -> their canonical target (permanent-redirect fallback; the
// authoritative 301s are configured at the edge/registrar). Path is preserved.
export const REDIRECT_MAP = {
  "www.azekaglobal.com": GLOBAL_ORIGIN,
  "azekaglobaltrade.com": GLOBAL_ORIGIN,
  "www.azekaglobaltrade.com": GLOBAL_ORIGIN,
  "www.azekahealth.com": HEALTH_ORIGIN,
};

function host() {
  return typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
}

// Base origin for canonical/OG/JSON-LD. Global-family hosts pin azekaglobal.com,
// Health-family hosts pin azekahealth.com; elsewhere (preview/dev, which is noindex)
// we use the live origin.
export function canonicalBase() {
  if (typeof window === "undefined") return GLOBAL_ORIGIN;
  const h = host();
  if (GLOBAL_FAMILY.includes(h)) return GLOBAL_ORIGIN;
  if (HEALTH_FAMILY.includes(h)) return HEALTH_ORIGIN;
  return window.location.origin;
}

export function canonicalUrl(path) {
  const p = path || (typeof window !== "undefined" ? window.location.pathname : "/");
  return canonicalBase() + p;
}
